import _ from 'lodash';
import { t } from '../../../components/common/Translate';

const mapClasses = {
  very_important: 'vincheck-alert-danger',
  informative: 'vincheck-alert-warning',
  default: 'vincheck-alert-warning',
};

const getClass = (alert) => (mapClasses[alert.level] ? mapClasses[alert.level] : mapClasses.default);

const getText = (alert) =>
  alert.category === 'missing_data' && alert.field ? `${t(alert.label)} (${t(alert.field)})` : t(alert.label);

const sortByLevel = (key) => {
  const sortingOrder = {
    very_important: 1,
    informative: 2,
  };
  return (a, b) => {
    if (!a[key] || !b[key]) return 0;

    const first = a[key].toLowerCase() in sortingOrder ? sortingOrder[a[key]] : Number.MAX_SAFE_INTEGER;
    const second = b[key].toLowerCase() in sortingOrder ? sortingOrder[b[key]] : Number.MAX_SAFE_INTEGER;

    let result = 0;
    if (first < second) result = -1;
    else if (first > second) result = 1;
    return result;
  };
};

export const alertsPresenter = (alerts) => {
  if (alerts) {
    alerts.sort(sortByLevel('level'));
    return Object.values(alerts).map((alert) => {
      _.set(alert, 'className', getClass(alert));
      _.set(alert, 'text', getText(alert));
      return alert;
    });
  }
  return null;
};
